// activeDealMapping.ts
import { DealStatusCount, OrganizationTableItem } from 'types'

const ACTIVE_STATUSES = new Set(['Active', 'In Progress', 'Month To Month', '30 Day Notice', 'Active (system)'])
export const useActiveDealMapping = () => {
  const getActiveDealMapping = (allDeals: OrganizationTableItem[] = []): Record<string, DealStatusCount> => {
    const mapping: Record<string, DealStatusCount> = {}

    for (const deal of allDeals) {
      const orgId = deal?.organizations?.[0]
      if (!orgId) continue
      if (!ACTIVE_STATUSES.has(deal?.dealStatus)) continue

      if (!mapping[orgId]) {
        mapping[orgId] = { active: 0, monthToMonth: 0, inProgress: 0, dayNotice: 0, total: 0 }
      }

      if (deal.dealStatus === 'Month To Month') mapping[orgId].monthToMonth += 1
      else if (deal.dealStatus === 'In Progress' || deal.dealStatus === 'In-Progress') mapping[orgId].inProgress += 1
      else if (deal.dealStatus === '30 Day Notice') mapping[orgId].dayNotice += 1
      else mapping[orgId].active += 1

      mapping[orgId].total += 1
    }

    return mapping
  }
  return getActiveDealMapping
}

// import { useMemo } from 'react'
// import { Deal, DealStatusCount, OrganizationTableItem } from 'types'

// export const useActiveDealMapping = (allDeals: OrganizationTableItem[]): Record<string, DealStatusCount> => {
//   const activeDealStatus = ['Active', 'In Progress', 'Month To Month', '30 Day Notice', 'Active (system)']

//   const activeDealMapping: Record<
//     string,
//     {
//       active: number
//       monthToMonth: number
//       inProgress: number
//       dayNotice: number
//       total: number
//     }
//   > = useMemo(() => {
//     const mapping: Record<
//       string,
//       {
//         active: number
//         monthToMonth: number
//         inProgress: number
//         dayNotice: number
//         total: number
//       }
//     > = {}

//     allDeals?.forEach(deal => {
//       const orgId = deal?.organizations?.[0]
//       if (!orgId) return

//       if (activeDealStatus.includes(deal.dealStatus)) {
//         if (!mapping[orgId]) {
//           mapping[orgId] = { active: 0, monthToMonth: 0, inProgress: 0, dayNotice: 0, total: 0 }
//         }

//         if (deal.dealStatus === 'Month To Month') mapping[orgId].monthToMonth += 1
//         else if (deal.dealStatus === 'In Progress' || deal.dealStatus === 'In-Progress') mapping[orgId].inProgress += 1
//         else if (deal.dealStatus === '30 Day Notice') mapping[orgId].dayNotice += 1
//         else mapping[orgId].active += 1

//         mapping[orgId].total += 1
//       }
//     })

//     return mapping
//   }, [allDeals])

//   return activeDealMapping
// }
